export const GET_CREDITCARDPAYMENT_REPORT = 'GET_CREDITCARDPAYMENT_REPORT';
export const GET_CREDITCARDPAYMENT_REPORT_ERROR =
  'GET_CREDITCARDPAYMENT_REPORT_ERROR';
export const CREDITCARDPAYMENT_REPORT_LOAD = 'CREDITCARDPAYMENT_REPORT_LOAD';
export const CLEAR_REPORT_DATA = 'CLEAR_REPORT_DATA';



// WEBPACK FOOTER //
// ./src/pages/creditcardpayment/state/types.js